<script setup>
/* eslint-disable */
import { onMounted, onUnmounted, watch, ref } from 'vue';
import { useSocketStore } from '@/stores/socket';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useMarketsStore } from '@/stores/markets';
import { useGeneralStore } from '@/stores/general';
import { useRouter, useRoute } from 'vue-router';
import { useSportPopularStore } from '@/stores/sport_popular';

import PreSportFeaturedFixtures from '@/components/pre_sports/PreSportFeaturedFixtures.vue';
import LiveOverview from '@/components/pre_sports/highlights/LiveOverview.vue';
import UpcomingOverview from '@/components/pre_sports/highlights/UpcomingOverview.vue';
import PopularOverview from '@/components/pre_sports/highlights/PopularOverview.vue';
import { useI18n } from 'vue-i18n';
import { SportsData } from '@/stores/Sports';

const socketStore = useSocketStore();
const preSportsStore = usePreSportsStore();
const liveSportsStore = useLiveSportsStore();
const marketsStore = useMarketsStore();
const liveSportOverviewStore = useLiveSportOverview();
const generalStore = useGeneralStore();
const sportPopularStore = useSportPopularStore();
const SportsDataStore = SportsData();

const router = useRouter();
const route = useRoute();

const { t } = useI18n();

const active_tab = ref('upcoming');

const show_primary_overview_market = ref(false);
const show_secondary_overview_market = ref(false);

const primary_overview_market = ref(null);
const secondary_overview_market = ref(null);

const show_scroll_to_top_button = ref(false);

const changeTab = (tab) => {
	active_tab.value = tab;
}

watch(() => liveSportOverviewStore.overviewFixturesCount, (newVal) => {
	if (active_tab.value == 'live' && newVal == 0) {
		active_tab.value = 'upcoming';
	}
});

const selectPrimaryOverviewMarket = (overview_market) => {
	primary_overview_market.value = overview_market;
	show_primary_overview_market.value = false;
}

const selectSecondaryOverviewMarket = (overview_market) => {
	secondary_overview_market.value = overview_market;
	show_secondary_overview_market.value = false;
}

const handleScroll = () => {
	const scrollTop = window.scrollY;
	show_scroll_to_top_button.value = scrollTop > 100;
};

const closePrimaryOverviewMarketSelector = () => {
	show_primary_overview_market.value = false;
}

const closeSecondaryOverviewMarketSelector = () => {
	show_secondary_overview_market.value = false;
}

const props = defineProps({
	primary_overview_market: {
		type: Object,
		required: true,
	},
});

onMounted(() => {
	if (router.currentRoute.value.params.sport_id != '') {
		let selected_pre_sport = _.find(preSportsStore.preSports, {'id': Number(router.currentRoute.value.params.sport_id) });
		if (selected_pre_sport) document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.highlights');

		let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);
		if (sport_overview_markets) {

			if (sport_overview_markets.length > 1) {
				primary_overview_market.value = sport_overview_markets[0];
				secondary_overview_market.value = sport_overview_markets[1];
			} else {
				primary_overview_market.value = sport_overview_markets[0];
				secondary_overview_market.value = sport_overview_markets[0]
			}
		}

		socketStore.join('sportHighlights', router.currentRoute.value.params.sport_id);
		socketStore.join('liveSportOverview', router.currentRoute.value.params.sport_id);
	}

	window.addEventListener('scroll', handleScroll);

})

onUnmounted( () => {
	socketStore.leave('sportHighlights', preSportsStore.selected_pre_sport_id);
	socketStore.leave('liveSportOverview');
	liveSportOverviewStore.emptyLiveSportsOverview();
})

watch(() => preSportsStore.preSports, (newSports, oldSports) => {
	if (oldSports.length == 0 && newSports.length > 0) {
		let selected_pre_sport = _.find(preSportsStore.preSports, {'id': Number(router.currentRoute.value.params.sport_id) });
		if (!selected_pre_sport) return;
		document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.highlights');
	}
})

watch(() => marketsStore.overview_markets, (newValue) => {
	if (!newValue) return;
	let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);
	if (sport_overview_markets.length > 1) {
		primary_overview_market.value = sport_overview_markets[0];

		secondary_overview_market.value = sport_overview_markets[1]
	} else {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[0]
	}
});

const scrollToTop = () => {
	window.scrollTo({ top: 0 });
};

watch(route, (to, from) => {
	if (!to.params.hasOwnProperty('sport_id') || to.params.sport_id == '') return;

	socketStore.join('sportHighlights', to.params.sport_id);
	socketStore.join('liveSportOverview', to.params.sport_id);

	let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);
	if (sport_overview_markets.length > 1) {
		primary_overview_market.value = sport_overview_markets[0];

		secondary_overview_market.value = sport_overview_markets[1]
	} else {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[0]
	}

	let selected_pre_sport = _.find(preSportsStore.preSports, {'id': Number(router.currentRoute.value.params.sport_id) });
	document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.highlights');

});
</script>

<template>
	<PreSportFeaturedFixtures v-if="sportPopularStore.getTopFeaturedFixtures.length > 0"/>

	<div class="live-bet-dashboard round-games-main set_game-outer">
		<div class="bet-dashboard-top">
			<div class="tabing-dashboard">
				<div class="tab-pills">
					<button class="tab-link" :class="active_tab == 'upcoming' ? 'active' : ''" data-tab-id="upcoming" @click="changeTab('upcoming')">{{$t('general.upcoming')}}</button>
					<button v-if="sportPopularStore.getTopFeaturedFixtures.length > 0" class="tab-link" :class="active_tab == 'popular' ? 'active' : ''" data-tab-id="popular" @click="changeTab('popular')">{{$t('general.popular')}}</button>
					<button v-if="liveSportOverviewStore.overviewFixturesCount > 0" class="tab-link last-btn" :class="active_tab == 'live' ? 'active' : ''" data-tab-id="live" @click="changeTab('live')">{{ $t('general.live') }} ({{ liveSportOverviewStore.overviewFixturesCount }})</button>
				</div>
			</div>
			<div class="dashboard-info-label bet-tab-title" >
				<h3 v-if="active_tab == 'upcoming'">{{ $t('general.upcoming') }}</h3>
				<h3 v-if="active_tab == 'popular'">{{ $t('general.popular') }}</h3>
				<h3 v-if="active_tab == 'live'">{{ $t('general.live') }} ({{ liveSportOverviewStore.overviewFixturesCount }})</h3>
			</div>
			<div class="dashboard-info-label dropdown-option-top" v-if="primary_overview_market">
				<div class="select-option">
					<dl class="drop" :class="show_primary_overview_market ? 'active' : ''">
						<span class="tabIco">
							<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
								</g>
							</svg>
						</span>
						<dt><button class="tablinks" @click="show_primary_overview_market = !show_primary_overview_market"  v-click-outside-element="closePrimaryOverviewMarketSelector">{{ primary_overview_market?.name?.toUpperCase() }}</button>
						</dt>
						<dd>
							<ul>
								<li v-for="overview_market in marketsStore.sportOverviewMarkets(preSportsStore.selected_pre_sport_id)" :key="overview_market.slug" @click="selectPrimaryOverviewMarket(overview_market)" :class="primary_overview_market.slug == overview_market.slug ? 'active' : ''">
									<button class="tablinks">{{ overview_market?.name?.toUpperCase() }}</button>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div>

			<div class="dashboard-info-label dropdown-option-top dropdown-option-top-2" v-if="secondary_overview_market">
				<div class="select-option">
					<dl class="drop" :class="show_secondary_overview_market ? 'active' : ''">
						<span class="tabIco">
							<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
								</g>
							</svg>
						</span>
						<dt><button class="tablinks" @click="show_secondary_overview_market = !show_secondary_overview_market"  v-click-outside-element="closeSecondaryOverviewMarketSelector">{{ secondary_overview_market?.name?.toUpperCase() }}</button>
						</dt>
						<dd>
							<ul>
								<li v-for="overview_market in marketsStore.sportOverviewMarkets(preSportsStore.selected_pre_sport_id)" :key="overview_market.slug" @click="selectSecondaryOverviewMarket(overview_market)" :class="secondary_overview_market.slug == overview_market.slug ? 'active' : ''">
									<button class="tablinks">{{ overview_market?.name?.toUpperCase() }}</button>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div>

			<div class="mobile-odds-heading">
				<div class="mobile-odds-heading-inner">
					<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
							<span v-if="odd != ''">{{ odd }}</span>
					</template>
				</div>

			</div>
		</div>

		<div class="live-tab-info" id="tabs">
			<LiveOverview v-if="active_tab == 'live'" :primary_overview_market="primary_overview_market" :secondary_overview_market="secondary_overview_market"/>
			<UpcomingOverview v-if="active_tab == 'upcoming'" :primary_overview_market="primary_overview_market" :secondary_overview_market="secondary_overview_market"/>
			<PopularOverview v-if="active_tab == 'popular'" :primary_overview_market="primary_overview_market" :secondary_overview_market="secondary_overview_market"/>
		</div>
	</div>
	<button @click="scrollToTop" type="button" class="btn scroll-to-top" id="btn-back-to-top" v-show="show_scroll_to_top_button">
		<i class="fas fa-arrow-up"></i>
	</button>
</template>
<style scoped>
.live-bet-dashboard.round-games-main .bet-dashboard-top:after {
	width: 100% !important;
}
@media screen and (min-width: 992px) and (max-width: 3000px) {
	button#btn-back-to-top {
		display:none;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		bottom: 95px;
		left: 20px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	svg.svg-inline--fa.fa-arrow-up.fa-w-14 {
		margin-bottom: 7px!important;
	}
	button#btn-back-to-top {
		width: 30px!important;
		height: 30px!important;
		font-size: 14px!important;
	}
}
button#btn-back-to-top {
	background: var(--primary);
	width: 38px;
	height: 38px;
	border: none;
	border-radius: 50%;
	position: fixed;
	z-index: 99;
	box-shadow: 0 2px 4px var(--list-gray);
	font-size: 16px;
	cursor: pointer;
}
html[dir="rtl"] button#btn-back-to-top {
	left: unset;
	right:20px;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		left: 10px;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	html[dir="rtl"] button#btn-back-to-top {
		left: unset;
		right:10px;
	}
}
@media screen and (min-width: 768px) {
	.tab-pills {
		padding-bottom: 12px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.dropdown-option-top-2 {
		display: none;
	}
}
@media screen and (min-width: 320px) and (max-width: 323px) {
	.last-btn {
		margin-top: 5px;
	}
}

html[dir="rtl"] .live-bet-dashboard .bet-dashboard-top:after {
	right: unset;
	left: 0px;
}

.live-tab-info {
	scrollbar-width: none !important;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	.live-tab-info {
		min-height: unset;
		max-height: unset;
		height: unset;
	}
}
</style>